import { Model } from '@/models/Model';
import { User } from './User';

export class Contractor extends Model {
  protected $name = 'Contractor';

  protected $endpoint = '/hin/contractors';

  protected $primaryKey = 'id';

  protected $fillable: string[] = ['name', 'coc', 'vat_number', 'registered_since', 'contact_name', 'contact_function', 'contact_email', 'site', 'phone'];

  public uuid?: string;

  public name?: string;

  public coc?: string;

  public vat_number?: string;

  public registered_since?: string;

  public purchase_order_number?: string;

  public contact_name?: string;

  public contact_function?: string;

  public contact_email?: string;

  public site?: string;

  public phone?: string;

  public user?: User;

  public address?: {
    postcode: '',
    number: '',
    number_add: '',
    city: '',
    street: '',
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateContractor(id: string, payload: ContractorCreatePayload): Promise<any> {
    const url = `${this.$endpoint}/${id}`;
    return this.request('patch', url, payload);
  }
}

export interface ContractorCreatePayload {
  name?: string;
  coc?: string;
  vat_number?: string;
  registered_since?: string;
  contact_name?: string;
  contact_function?: string;
  contact_email?: string;
  site?: string;
  phone?: string;
  password?: string;
}
